import PropertyAdForm from "../../../../components/forms/propertyAdform";

const UpdatePersonalProperty = () => {
    return (
        <div>
            <PropertyAdForm  title="Update Personal Property Category,Location,Price,Description" btn="Update"/>
        </div>
    )
}
export default UpdatePersonalProperty;